import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Stick } from '@ifeng-fe/three_terminal/es/mobile/index';
import NoSSR from 'react-no-ssr';
import styles from './index.css';

class NewsInTopComponent extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
        componentOptions: PropTypes.object,
    };

    // 随机数据
    randomData(data, children) {
        const arr = [data, ...children, data, ...children, data, ...children, data, ...children];
        const index = Math.floor(Math.random() * arr.length);

        return arr[index];
    }

    newsListView(list = [], componentOptions) {
        const random = componentOptions && componentOptions.random;

        return list.map((item, index) => {
            let rItem = item;

            if (random && item.children) {
                rItem = this.randomData(item, item.children);
            }

            rItem = {
                ...rItem,
                isShowTopText: false,
            };

            return <Stick key={index} item={rItem} url={rItem.url} />;
        });
    }

    render() {
        const { content, componentOptions } = this.props;

        return (
            <div className={styles.box}>
                <h1 className={styles.title}>今日要闻</h1>
                <NoSSR>
                    <div>{this.newsListView(content, componentOptions)}</div>
                </NoSSR>
            </div>
        );
    }
}

export default NewsInTopComponent;
